// The shared colour picker: colorMenu(target) for anything with a colour of its own (the background, notes): the
// preset swatches, the native picker and a hex field, in a panel that lives in the page and moves into the menu.
import { hideMenu, submenu } from './menu.js';
import { toast } from './ui.js';

const $bgPicker = document.getElementById('bg-picker');
// Colour picking, shared by everything that has a colour (the background, notes, ...). colorMenu(target) opens a
// menu level with the target's title, the preset swatches, a native <input type=color> and a hex field. A target
// is { title, get() -> '#rrggbb' | null, fallback() -> the colour shown when there is none, preview(c), save(c) };
// null means "no colour of its own". The panel element lives in the page and is moved into the menu when shown,
// so its inputs keep their listeners. The native picker cannot be positioned by the page, so it is one more control.
const $colorPanel = document.getElementById('color-panel');
const $colorHex = document.getElementById('bg-hex');
export const $colorPicker = $bgPicker;
// Clear (null: no colour of its own) first, then eleven clearly different hues, dark enough for white text.
const PRESETS = [null, '#334155', '#1d4ed8', '#4338ca', '#7e22ce', '#be185d',
                 '#b91c1c', '#c2410c', '#b45309', '#4d7c0f', '#047857', '#0e7490'];
const HEX = /^#[0-9a-f]{6}$/i;
const normHex = (v) => { v = v.trim(); if (v && v[0] !== '#') v = `#${v}`; return HEX.test(v) ? v.toLowerCase() : null; };
let colorTarget = null; // the target the open colour menu is editing

export function colorMenu(target) {
  submenu(() => {
    colorTarget = target;
    const cur = normHex(target.get() || '');
    $colorPicker.value = cur || target.fallback(); $colorHex.value = cur || ''; $colorHex.placeholder = target.fallback();
    $colorPanel.querySelector('.swatches').replaceChildren(...PRESETS.map((c) => {
      const b = document.createElement('button');
      b.type = 'button'; b.className = c ? 'swatch' : 'swatch clear'; b.dataset.color = c ?? ''; b.title = c ?? 'Clear';
      if (c) b.style.background = c;
      b.addEventListener('click', () => { previewColor(c); saveColor(c); });
      return b;
    }));
    markSwatch(cur);
    $colorPanel.hidden = false;
    return [{ label: target.title, cls: 'head' }, { node: $colorPanel }];
  });
}
function markSwatch(c) {
  $colorPanel.querySelectorAll('.swatch').forEach((b) => b.classList.toggle('current', b.dataset.color === (c ?? '')));
}
// Show a colour without saving it; null clears it. `from` is the control that produced it, left untouched.
function previewColor(c, from) {
  colorTarget.preview(c);
  if (from !== $colorPicker) $colorPicker.value = c || colorTarget.fallback();
  if (from !== $colorHex) $colorHex.value = c || '';
  markSwatch(c);
}
async function saveColor(c) {
  try { await colorTarget.save(c); } catch (e) { toast(e); }
}

// Event wiring and first drawing, run once by client.js in the order the parts of the page depend on.
export function init() {
  $colorPicker.addEventListener('input', () => previewColor($colorPicker.value, $colorPicker));
  $colorPicker.addEventListener('change', () => saveColor($colorPicker.value));
  $colorHex.addEventListener('input', () => { const c = normHex($colorHex.value); if (c) previewColor(c, $colorHex); });
  $colorHex.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    const c = normHex($colorHex.value);
    if (!c) return toast(`Use a color like ${colorTarget.fallback()}`, { kind: 'error' });
    saveColor(c);
    hideMenu();
  });
}
